import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/auth/me`, {
        withCredentials: true,
      });
      setUser(data);
    } catch (error) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password, rememberMe = true) => {
    const { data } = await axios.post(
      `${API_URL}/api/auth/login`,
      { email, password, remember_me: rememberMe },
      { withCredentials: true }
    );
    setUser(data);
    if (rememberMe) {
      localStorage.setItem('ops_suite_user', 'true');
    }
    return data;
  };

  const register = async (email, password, name, role, consents) => {
    const payload = { email, password, name, role };
    if (consents) {
      payload.consents = consents;
    }
    const { data } = await axios.post(
      `${API_URL}/api/auth/register`,
      payload,
      { withCredentials: true }
    );
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API_URL}/api/auth/logout`, {}, { withCredentials: true });
    localStorage.removeItem('ops_suite_user');
    setUser(false);
  };

  const updateUser = (updates) => {
    setUser(prev => prev ? { ...prev, ...updates } : prev);
  };

  const [viewAsRole, setViewAsRole] = useState(null);

  const switchRole = (role) => {
    setViewAsRole(role);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth, switchRole, viewAsRole: viewAsRole || user?.role, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
